<template>
  <PageWrapper :maxWidth="5000">
    <b-row class="margin-0 jobs-profile__detail">
      <b-col cols="12" class="padding-0">
        <CardWrapper
          :menuItems="itemButtons"
          :permissions="permissions"
          :isShowMenu="isJobMenu"
          @handleOpenMenu="handleOpenJobMenu"
          @handleCloseMenu="handleCloseJobMenu"
        >
          <template #title>
            <span class="color-complementary-400 font-size-16">مدیر مالی</span>
          </template>
          <template #content>
            <div class="jobs-profile__description">
              لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با
              استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله
              در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد
              نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد،
              کتابهای زیادی در شصت و سه درصد گذشته حال و آین
            </div>
            <div class="jobs-profile__footer-text">
              شغل های مرتبط: کارشناس حسابداری، کارشناس طراحی، مدیر طراحی، مدیر
              فنی
            </div>
          </template>
        </CardWrapper>
      </b-col>
      <b-col cols="12" class="padding-0 position-sticky top-60">
        <Tabs class="" :tabs="tabs" :isDesktopTabs="true">
          <template #tab-0>
            <div>
              <div class="flex-start-between">
                <div class="desktop-width-max-content">
                  <Input
                    :value="form.searchTxt"
                    name="searchTxt"
                    id="searchTxt"
                    type="text"
                    :placeholder="$lang.search"
                    :vuelidateObj="$v.form.searchTxt"
                    :hasEraseIcon="!!form.searchTxt"
                    :autoFocus="true"
                    rightIcon="magnify"
                    :loading="loading"
                    @input="getSearchText"
                    @erase="eraseSearchText"
                  />
                </div>
                <DropdownModal>
                  <template #click-area>
                    <Button
                      variant="primary"
                      rightIcon="file-document-outline"
                      leftIcon="chevron-down"
                      :text="$lang.contents"
                    />
                  </template>
                  <template #content>
                    <b-row class="margin-0">
                      <b-col
                        cols="12"
                        md="6"
                        class="margin-bottom-32 border--solid border--bottom border--complementary-50 desktop-border-none"
                      >
                        <ul class="margin-0 padding-0 list-style--none">
                          <li
                            class="font-size-16 color-complementary-400 margin-bottom-8"
                          >
                            الزامات شغلی
                          </li>
                          <router-link
                            tag="li"
                            :to="{ name: 'jobs-profile-detail' }"
                            v-for="(item, index) in Array(3).fill(1)"
                            :key="`a-${index}`"
                            class="font-size-14 color-complementary-300 margin-bottom-8 padding-y-4 padding-x-12 border-radius-4 is-hover cursor--pointer"
                          >
                            فعالیت های شغلی
                          </router-link>
                        </ul>
                      </b-col>
                      <b-col
                        cols="12"
                        md="6"
                        class="margin-bottom-32 border--solid border--bottom border--complementary-50 desktop-border-none"
                      >
                        <ul class="margin-0 padding-0 list-style--none">
                          <li
                            class="font-size-16 color-complementary-400 margin-bottom-8"
                          >
                            الزامات شغلی
                          </li>
                          <router-link
                            tag="li"
                            :to="{ name: 'jobs-profile-detail' }"
                            v-for="(item, index) in Array(3).fill(1)"
                            :key="`b-${index}`"
                            class="font-size-14 color-complementary-300 margin-bottom-8 padding-y-4 padding-x-12 border-radius-4 is-hover cursor--pointer"
                          >
                            فعالیت های شغلی
                          </router-link>
                        </ul>
                      </b-col>
                      <b-col
                        cols="12"
                        md="6"
                        class="margin-bottom-32 border--solid border--bottom border--complementary-50 desktop-border-none"
                      >
                        <ul class="margin-0 padding-0 list-style--none">
                          <li
                            class="font-size-16 color-complementary-400 margin-bottom-8"
                          >
                            الزامات شغلی
                          </li>
                          <router-link
                            tag="li"
                            :to="{ name: 'jobs-profile-detail' }"
                            v-for="(item, index) in Array(3).fill(1)"
                            :key="`c-${index}`"
                            class="font-size-14 color-complementary-300 margin-bottom-8 padding-y-4 padding-x-12 border-radius-4 is-hover cursor--pointer"
                          >
                            فعالیت های شغلی
                          </router-link>
                        </ul>
                      </b-col>
                      <b-col
                        cols="12"
                        md="6"
                        class="margin-bottom-32 border--solid border--bottom border--complementary-50 desktop-border-none"
                      >
                        <ul class="margin-0 padding-0 list-style--none">
                          <li
                            class="font-size-16 color-complementary-400 margin-bottom-8"
                          >
                            الزامات شغلی
                          </li>
                          <router-link
                            tag="li"
                            :to="{ name: 'jobs-profile-detail' }"
                            v-for="(item, index) in Array(3).fill(1)"
                            :key="`d-${index}`"
                            class="font-size-14 color-complementary-300 margin-bottom-8 padding-y-4 padding-x-12 border-radius-4 is-hover cursor--pointer"
                          >
                            فعالیت های شغلی
                          </router-link>
                        </ul>
                      </b-col>
                    </b-row>
                  </template>
                </DropdownModal>
              </div>
              <CardWrapper
                :menuItems="taskMenuItems"
                :permissions="permissions"
                :isShowMenu="isTaskMenu"
                @handleOpenMenu="handleOpenTaskMenu"
                @handleCloseMenu="handleCloseTaskMenu"
              >
                <template #title>
                  <div class="flex-center">
                    <span class="jobs-profile__title">وظایف</span>
                    <Dropdown
                      :value="form.taskPerPage"
                      :options="perPageOptions"
                      name="taskPerPage"
                      id="taskPerPage"
                      inputPlaceholder=""
                      rowClass="margin-right-16"
                      :hasRemoveIcon="false"
                      @input="input"
                    />
                  </div>
                </template>
                <template #content>
                  <ul class="margin-0 padding-0 list-style--none">
                    <li
                      v-for="(item, index) in Array(3).fill(0)"
                      :key="`e-${index}`"
                      class="margin-bottom-8"
                    >
                      <span class="color-complementary-300 margin-left-8">
                        <mdicon name="plus-circle" size="20" />
                      </span>
                      <span class="font-size-14 color-complementary-300">
                        لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت
                        چاپ، و با استفاده از طراحان گرافیک است.
                      </span>
                    </li>
                  </ul>
                </template>
              </CardWrapper>
              <CardWrapper
                :menuItems="techMenuItems"
                :permissions="permissions"
                :isShowMenu="isTechMenu"
                @handleOpenMenu="handleOpenTechMenu"
                @handleCloseMenu="handleCloseTechMenu"
              >
                <template #title>
                  <div class="flex-center">
                    <span class="jobs-profile__title">تکنولوژی</span>
                    <Dropdown
                      :value="form.techPerPage"
                      :options="perPageOptions"
                      name="techPerPage"
                      id="techPerPage"
                      inputPlaceholder=""
                      rowClass="margin-right-16"
                      :hasRemoveIcon="false"
                      @input="input"
                    />
                  </div>
                </template>
                <template #content>
                  <ul class="margin-0 padding-0 list-style--none">
                    <li
                      v-for="(item, index) in Array(3).fill(0)"
                      :key="`f-${index}`"
                      class="margin-bottom-8"
                    >
                      <span class="color-complementary-300 margin-left-8">
                        <mdicon name="plus-circle" size="20" />
                      </span>
                      <span
                        class="font-size-12 color-complementary-400 margin-left-2 font-weight-500"
                      >
                        طراحی:
                      </span>
                      <span class="font-size-12 color-complementary-300">
                        طراحی رابط کاربری، طراحی تجربه کاربر
                      </span>
                    </li>
                  </ul>
                </template>
              </CardWrapper>
              <CardWrapper
                :menuItems="educationMenuItems"
                :permissions="permissions"
                :isShowMenu="isEducationMenu"
                @handleOpenMenu="handleOpenEducationMenu"
                @handleCloseMenu="handleCloseEducationMenu"
              >
                <template #title>
                  <div class="flex-center">
                    <span class="jobs-profile__title">تحصیلات</span>
                    <Dropdown
                      :value="form.educationPerPage"
                      :options="perPageOptions"
                      name="educationPerPage"
                      id="educationPerPage"
                      inputPlaceholder=""
                      rowClass="margin-right-16"
                      :hasRemoveIcon="false"
                      @input="input"
                    />
                  </div>
                </template>
                <template #content>
                  <ul class="margin-0 padding-0 list-style--none">
                    <li
                      v-for="(item, index) in Array(3).fill(0)"
                      :key="`j-${index}`"
                      class="margin-bottom-8 flex-start"
                    >
                      <InlineProgress :percent="50" />
                      <span class="font-size-12 color-complementary-300">
                        طراحی رابط کاربری، طراحی تجربه کاربر
                      </span>
                    </li>
                  </ul>
                </template>
              </CardWrapper>
            </div>
          </template>
          <template #tab-1>
            <div>
              <CardWrapper
                :menuItems="tableTaskMenuItems"
                :permissions="permissions"
                :isShowMenu="isTableTaskMenu"
                @handleOpenMenu="handleOpenTableTaskMenu"
                @handleCloseMenu="handleCloseTableTaskMenu"
              >
                <template #title>
                  <div class="flex-center">
                    <span class="jobs-profile__title">وظایف</span>
                    <Dropdown
                      :value="form.tableTaskPerPage"
                      :options="perPageOptions"
                      name="tableTaskPerPage"
                      id="tableTaskPerPage"
                      inputPlaceholder=""
                      rowClass="margin-right-16"
                      :hasRemoveIcon="false"
                      @input="input"
                    />
                  </div>
                </template>
                <template #content>
                  <SortTable :labels="sortTableLabels" :items="sortTableItems">
                    <template slot="body-row" slot-scope="{ item }">
                      <InlineProgress :percent="item.percent" />
                      <span class="font-size-14 color-complementary-300">
                        {{ item.category }}
                      </span>
                      <div class="">
                        <span class="color-complementary-300 margin-left-8">
                          <mdicon name="plus-circle" size="20" />
                        </span>
                        <span class="font-size-14 color-complementary-300">
                          {{ item.task }}
                        </span>
                      </div>
                    </template>
                  </SortTable>
                </template>
              </CardWrapper>
              <CardWrapper
                :menuItems="workContentMenuItems"
                :permissions="permissions"
                :isShowMenu="isWorkContentMenu"
                @handleOpenMenu="handleOpenWorkContentMenu"
                @handleCloseMenu="handleCloseWorkContentMenu"
              >
                <template #title>
                  <div class="flex-center">
                    <span class="jobs-profile__title">محتوای کار</span>
                    <Dropdown
                      :value="form.workContentPerPage"
                      :options="perPageOptions"
                      name="workContentPerPage"
                      id="workContentPerPage"
                      inputPlaceholder=""
                      rowClass="margin-right-16"
                      :hasRemoveIcon="false"
                      @input="input"
                    />
                  </div>
                </template>
                <template #content>
                  <ul class="margin-0 padding-0 list-style--none">
                    <li
                      v-for="(item, index) in Array(3).fill(0)"
                      :key="`k-${index}`"
                      class="margin-bottom-8"
                    >
                      <div class="margin-bottom-8">
                        <span class="color-complementary-300 margin-left-8">
                          <mdicon name="plus-circle" size="20" />
                        </span>
                        <span class="font-size-14 color-complementary-300">
                          لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت
                          چاپ، و با استفاده از طراحان گرافیک است.
                        </span>
                      </div>
                      <InlineProgress :percent="50" suffixText="هرروز" />
                    </li>
                  </ul>
                </template>
              </CardWrapper>
              <CardWrapper
                :menuItems="similarJobsMenuItems"
                :permissions="permissions"
                :isShowMenu="isSimilarJobsMenu"
                @handleOpenMenu="handleOpenSimilarJobsMenu"
                @handleCloseMenu="handleCloseSimilarJobsMenu"
              >
                <template #title>
                  <div class="flex-center">
                    <span class="jobs-profile__title">شغل های مرتبط</span>
                    <Dropdown
                      :value="form.similarJobsPerPage"
                      :options="perPageOptions"
                      name="similarJobsPerPage"
                      id="similarJobsPerPage"
                      inputPlaceholder=""
                      rowClass="margin-right-16"
                      :hasRemoveIcon="false"
                      @input="input"
                    />
                  </div>
                </template>
                <template #content>
                  <ul class="margin-0 padding-0 list-style--none">
                    <li
                      v-for="(item, index) in Array(3).fill(0)"
                      :key="`l-${index}`"
                      class="margin-bottom-8 flex-start"
                    >
                      <span
                        class="font-size-14 color-complementary-300 margin-left-8"
                      >
                        1398/2/12
                      </span>
                      <router-link
                        tag="span"
                        :to="{ name: 'jobs-profile-detail' }"
                        class="color-primary font-size-14 text-decoration-underline cursor--pointer margin-bottom-8"
                      >
                        حسابداران و حسابرسان
                      </router-link>
                    </li>
                  </ul>
                </template>
              </CardWrapper>
            </div>
          </template>
        </Tabs>
      </b-col>
    </b-row>
  </PageWrapper>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import PageWrapper from "@/components/re-design/wrappers/PageWrapper.vue";
import Tabs from "@/components/re-design/tabs/Tabs.vue";
import DropdownModal from "@/components/re-design/modal/DropdownModal.vue";
import { Button, Input, Dropdown } from "@/components/re-design/forms";
import CardWrapper from "./components/CardWrapper.vue";
import InlineProgress from "./components/InlineProgress.vue";
import SortTable from "./components/SortTable.vue";
import { required } from "vuelidate/lib/validators";

export default {
  mixins: [inputMixin],
  components: {
    PageWrapper,
    Tabs,
    DropdownModal,
    Button,
    Input,
    Dropdown,
    CardWrapper,
    InlineProgress,
    SortTable,
  },
  validations() {
    return {
      form: {
        searchTxt: {},
        taskPerPage: {},
        techPerPage: {},
        educationPerPage: {},
        workContentPerPage: {},
        similarJobsPerPage: {},
        tableTaskPerPage: {},
      },
    };
  },
  data() {
    return {
      form: {
        searchTxt: null,
        taskPerPage: { id: 5, caption: "نمایش 5 از 25" },
        techPerPage: { id: 5, caption: "نمایش 5 از 25" },
        educationPerPage: { id: 5, caption: "نمایش 5 از 25" },
        workContentPerPage: { id: 5, caption: "نمایش 5 از 25" },
        similarJobsPerPage: { id: 5, caption: "نمایش 5 از 25" },
        tableTaskPerPage: { id: 5, caption: "نمایش 5 از 25" },
      },
      permissions: ["admin", "edit"],
      isJobMenu: false,
      loading: false,
      isTaskMenu: false,
      isTechMenu: false,
      isEducationMenu: false,
      isWorkContentMenu: false,
      isSimilarJobsMenu: false,
      isTableTaskMenu: false,
      tabs: [
        {
          icon: "file-document-outline",
          text: "خلاصه",
        },
        {
          icon: "text-box-search-outline",
          text: "جزییات",
        },
      ],
    };
  },
  computed: {
    itemButtons() {
      return [
        {
          caption: this.$lang.edit,
          icon: "pencil-outline",
          show: true,
          permissions: ["admin", "edit"],
          loading: false,
          click: () => {},
        },
        {
          caption: this.$lang.delete,
          icon: "trash-can-outline",
          show: true,
          permissions: ["admin", "edit"],
          loading: false,
          click: () => {},
        },
        {
          caption: this.$lang.clone_tooltip,
          icon: "content-copy",
          show: true,
          permissions: ["admin", "edit"],
          loading: false,
          click: () => {},
        },
      ];
    },
    taskMenuItems() {
      return [
        {
          caption: this.$lang.edit,
          icon: "pencil-outline",
          show: true,
          permissions: ["admin", "edit"],
          loading: false,
          click: () => {},
        },
        {
          caption: this.$lang.delete,
          icon: "trash-can-outline",
          show: true,
          permissions: ["admin", "edit"],
          loading: false,
          click: () => {},
        },
      ];
    },
    techMenuItems() {
      return [
        {
          caption: this.$lang.edit,
          icon: "pencil-outline",
          show: true,
          permissions: ["admin", "edit"],
          loading: false,
          click: () => {},
        },
        {
          caption: this.$lang.delete,
          icon: "trash-can-outline",
          show: true,
          permissions: ["admin", "edit"],
          loading: false,
          click: () => {},
        },
      ];
    },
    educationMenuItems() {
      return [
        {
          caption: this.$lang.edit,
          icon: "pencil-outline",
          show: true,
          permissions: ["admin", "edit"],
          loading: false,
          click: () => {},
        },
        {
          caption: this.$lang.delete,
          icon: "trash-can-outline",
          show: true,
          permissions: ["admin", "edit"],
          loading: false,
          click: () => {},
        },
      ];
    },
    workContentMenuItems() {
      return [
        {
          caption: this.$lang.edit,
          icon: "pencil-outline",
          show: true,
          permissions: ["admin", "edit"],
          loading: false,
          click: () => {},
        },
        {
          caption: this.$lang.delete,
          icon: "trash-can-outline",
          show: true,
          permissions: ["admin", "edit"],
          loading: false,
          click: () => {},
        },
      ];
    },
    similarJobsMenuItems() {
      return [
        {
          caption: this.$lang.edit,
          icon: "pencil-outline",
          show: true,
          permissions: ["admin", "edit"],
          loading: false,
          click: () => {},
        },
        {
          caption: this.$lang.delete,
          icon: "trash-can-outline",
          show: true,
          permissions: ["admin", "edit"],
          loading: false,
          click: () => {},
        },
      ];
    },
    tableTaskMenuItems() {
      return [
        {
          caption: this.$lang.edit,
          icon: "pencil-outline",
          show: true,
          permissions: ["admin", "edit"],
          loading: false,
          click: () => {},
        },
        {
          caption: this.$lang.delete,
          icon: "trash-can-outline",
          show: true,
          permissions: ["admin", "edit"],
          loading: false,
          click: () => {},
        },
      ];
    },
    perPageOptions() {
      return new Array(5).fill(0).map((item, index) => {
        const id = (index + 1) * 5;
        return { id, caption: `نمایش ${id} از 25` };
      });
    },
    sortTableLabels() {
      return [
        {
          label: "اهمیت",
          isSortable: true,
          width: "13%",
        },
        {
          label: "دسته بندی",
          isSortable: true,
          width: "10%",
        },
        {
          label: "وضایف",
          isSortable: true,
          width: "78%",
        },
      ];
    },
    sortTableItems() {
      return [
        {
          id: 1,
          percent: 50,
          category: "مکمل",
          task: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است.",
        },
        {
          id: 2,
          percent: 40,
          category: "مکمل",
          task: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است.",
        },
        {
          id: 3,
          percent: 77,
          category: "مکمل",
          task: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است.",
        },
      ];
    },
  },
  methods: {
    handleOpenJobMenu() {
      this.isJobMenu = true;
    },
    handleCloseJobMenu() {
      this.isJobMenu = false;
    },
    handleOpenTaskMenu() {
      this.isTaskMenu = true;
    },
    handleCloseTaskMenu() {
      this.isTaskMenu = false;
    },
    handleOpenTechMenu() {
      this.isTechMenu = true;
    },
    handleCloseTechMenu() {
      this.isTechMenu = false;
    },
    handleOpenEducationMenu() {
      this.isEducationMenu = true;
    },
    handleCloseEducationMenu() {
      this.isEducationMenu = false;
    },
    handleOpenWorkContentMenu() {
      this.isWorkContentMenu = true;
    },
    handleCloseWorkContentMenu() {
      this.isWorkContentMenu = false;
    },
    handleOpenSimilarJobsMenu() {
      this.isSimilarJobsMenu = true;
    },
    handleCloseSimilarJobsMenu() {
      this.isSimilarJobsMenu = false;
    },
    handleOpenTableTaskMenu() {
      this.isTableTaskMenu = true;
    },
    handleCloseTableTaskMenu() {
      this.isTableTaskMenu = false;
    },
    eraseSearchText() {
      // remove text search data
      this.form.searchTxt = null;
      this.items = [];
      this.fetchData();
    },
    getSearchText(key, value) {
      // call of input mixin
      this.input(key, value);

      if (this.debounceGet) {
        clearTimeout(this.debounceGet);
        this.debounceGet = null;
      }
      this.debounceGet = setTimeout(() => {
        this.fetchData();
      }, this.debounceTime);
    },
    async fetchData() {
      try {
        this.loading = true;
        const response = await getJobsProfile(this.form.searchTxt);
        const { items } = response;
        this.items = [...items];
      } catch (error) {
        generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
